import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  NAV_LOGO_SIZE,
  CONTACT_EMAIL,
  CONTACT_PHONE_DISPLAY,
  CONTACT_PHONE_TEL,
} from "../lib/constants";

const NAV_ITEMS = [
  { key: "build", to: "#build", label: "What We Build" },
  { key: "how", to: "#how", label: "How We Work" },
  { key: "measure", to: "#measure", label: "Measurement" },
  { key: "why", to: "#why", label: "Why HOL" },
];

export function SiteNav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const onHome = location.pathname === "/";

  const scrollToSection = (hash) => (e) => {
    e.preventDefault();
    setOpen(false);
    if (!onHome) {
      navigate("/" + hash);
      return;
    }
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const goHome = (e) => {
    e.preventDefault();
    setOpen(false);
    if (onHome) window.scrollTo({ top: 0, behavior: "smooth" });
    else navigate("/");
  };

  return (
    <nav className="nav" data-testid="site-nav" aria-label="Primary">
      <button className="nav-logo" onClick={goHome} data-testid="nav-logo" aria-label="HOL Creative Solutions, back to top">
        <img
          src="/hol/logo-mark-transparent.png"
          alt=""
          width={NAV_LOGO_SIZE}
          height={NAV_LOGO_SIZE}
          data-testid="nav-logo-image"
          style={{ display: "block", objectFit: "contain" }}
        />
        <span>
          <span className="nl-primary">HOL</span>
          <span className="nl-sub">Creative Solutions</span>
        </span>
      </button>

      <ul className={`nav-links ${open ? "open" : ""}`} data-testid="nav-links">
        {NAV_ITEMS.map((item) => (
          <li key={item.key}>
            <a
              href={item.to}
              onClick={scrollToSection(item.to)}
              data-testid={`nav-link-${item.key}`}
            >
              {item.label}
            </a>
          </li>
        ))}
        <li>
          <a
            href="#contact"
            className="nav-cta"
            onClick={scrollToSection("#contact")}
            data-testid="nav-link-contact"
          >
            Book a Growth Strategy Session
          </a>
        </li>
      </ul>

      <button
        className="nav-mobile-toggle"
        onClick={() => setOpen((s) => !s)}
        aria-label="Toggle menu"
        aria-expanded={open}
        data-testid="mobile-menu-toggle"
      >
        <span /><span /><span />
      </button>
    </nav>
  );
}

export function SiteFooter() {
  const navigate = useNavigate();
  const scrollToHome = (hash) => (e) => {
    e.preventDefault();
    navigate("/" + hash);
  };

  return (
    <footer className="footer" data-testid="site-footer">
      <div className="wrap">
        <div className="footer-grid">
          <div className="footer-brand">
            <button
              onClick={scrollToHome("")}
              data-testid="footer-logo"
              style={{ background: "none", border: "none", padding: 0, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 12 }}
            >
              <img
                src="/hol/logo-mark-transparent.png"
                alt=""
                width={44}
                height={44}
                data-testid="footer-logo-image"
                style={{ display: "block", objectFit: "contain" }}
              />
              <span>
                <span className="nl-primary" style={{ fontFamily: "Fraunces, serif", fontSize: "1.15rem", color: "var(--text)" }}>HOL</span>
                <span className="nl-sub" style={{ display: "block", fontSize: "0.62rem", letterSpacing: "0.24em", textTransform: "uppercase", color: "var(--text-muted)", marginTop: 2 }}>Creative Solutions</span>
              </span>
            </button>
            <p style={{ marginTop: 20, color: "var(--text-muted)", fontSize: "0.92rem" }}>
              Operations infrastructure for local service businesses.
              <br />
              Websites, CRM, AI, automation, SEO, analytics, and continuous optimization.
            </p>
          </div>

          <div>
            <h4>Site</h4>
            <ul>
              <li><button onClick={scrollToHome("#build")}>What We Build</button></li>
              <li><button onClick={scrollToHome("#how")}>How We Work</button></li>
              <li><button onClick={scrollToHome("#measure")}>Measurement</button></li>
              <li><button onClick={scrollToHome("#tech")}>Powered By</button></li>
              <li><button onClick={scrollToHome("#industries")}>Industries</button></li>
              <li><button onClick={scrollToHome("#faq")}>FAQ</button></li>
              <li><button onClick={scrollToHome("#contact")}>Contact</button></li>
            </ul>
          </div>

          <div>
            <h4>Reach Us</h4>
            <ul>
              <li>
                <a href={`tel:${CONTACT_PHONE_TEL}`} data-testid="footer-phone-link" style={{ color: "var(--gold)" }}>
                  {CONTACT_PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email-link">
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li style={{ color: "var(--text-faint)", fontSize: "0.82rem", marginTop: 6 }}>
                Central Indiana and beyond
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} HOL Creative Solutions LLC. All rights reserved.</span>
          <span>Precision operations infrastructure.</span>
        </div>
      </div>
    </footer>
  );
}
